export const SET_IS_RHS_COLLAPSED = 'SET_IS_RHS_COLLAPSED';

export const setIsRHSCollapsed = (payload) => {
    return { type: SET_IS_RHS_COLLAPSED, payload };
};
